import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import Modal, { ActionModalButton, } from '../modal';
import { Icon, Text } from '../../elementals';
const GeneralModal = ({ title, children, elmId = 'general_modal', size = 'tiny', onClose, actions, preventClose = false, ...rest }) => {
    const actionButtons = useMemo(() => {
        if (!actions)
            return null;
        return actions.map((action, index) => {
            return (_jsx(ActionModalButton, { ...action, onClick: async (event, data) => {
                    await action?.onClick?.(event, data);
                    !preventClose && onClose();
                } }, index));
        });
    }, [actions, onClose]);
    return (_jsxs(Modal, { ...rest, title: title, elmId: elmId, closeIcon: _jsx(Icon, { className: 'close', "data-elm-id": `${elmId}_close_button`, name: 'times', iconStyle: 'regular', fitted: true, onClick: onClose }), size: size, children: [_jsx(Modal.Content, { children: typeof children === 'string' ? (_jsx(Text.Body, { children: children })) : (children) }), actionButtons && _jsx(Modal.Actions, { children: actionButtons })] }));
};
export default GeneralModal;
//# sourceMappingURL=index.js.map